import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/auth.context.js";
import { changePasswordUser, uploadAvatar } from "../../api/user.api.js";
import {
  Avatar,
  Button,
  Divider,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSnackbar } from "../../context/snackbar.context.js";

const ProfileSettingsPage = () => {
  const auth = useAuth();
  const showSnackbar = useSnackbar();

  const [formData, setFormData] = useState({
    newPassword: "",
    oldPassword: "",
  });

  useEffect(() => {}, [auth]);

  const handleSubmit = (e) => {
    e.preventDefault();
    changePasswordUser(formData.newPassword, formData.oldPassword).then(
      (response) => {
        if (response.data) {
          auth.logout();
        }
      }
    );
  };

  const handleUpload = (file) => {
    uploadAvatar(file)
      .then((e) => {
        showSnackbar("Avatar uploaded! Please refresh page!", "success");
      })
      .catch((error) => {
        showSnackbar("Failed to upload Avatar!", "error");
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  return (
    <div>
      {auth.user && (
        <div className="content-container">
          <div>
            <Typography variant="h3">Profile</Typography>
            <Typography>{auth.user.nickname}</Typography>
            <Typography>{auth.user.fullName}</Typography>
            <Typography>{auth.user.email}</Typography>
          </div>

          <Divider />

          <div>
            <form>
              <Typography>Change Avatar</Typography>
              {auth && auth.user && auth.user.avatarFileName === "" && (
                <div>No avatar</div>
              )}
              {auth && auth.user && auth.user.avatarFileName !== "" && (
                <Avatar
                  sx={{ width: 48, height: 48 }}
                  alt={auth.user.nickname}
                  src={`/static/images/${
                    auth.user.avatarFileName ?? "default.jpg"
                  }`}
                />
              )}
              <div>
                <Button
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  startIcon={<FileUploadIcon />}
                >
                  Upload Avatar
                  <VisuallyHiddenInput
                    type="file"
                    onChange={(event) => handleUpload(event.target.files[0])}
                  />
                </Button>
              </div>
            </form>
          </div>

          <Divider />
          <div>
            <form onSubmit={handleSubmit}>
              <Typography>Change Password</Typography>
              <div>
                <TextField
                  id="oldPassword"
                  label="Actual Password"
                  name="oldPassword"
                  variant="outlined"
                  type="password"
                  fullWidth
                  value={formData.oldPassword}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div>
                <TextField
                  id="newPassword"
                  label="New Password"
                  name="newPassword"
                  variant="outlined"
                  type="password"
                  fullWidth
                  value={formData.newPassword}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <Button variant="contained" type="submit">
                Update and Logout
              </Button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileSettingsPage;
